// extracted by mini-css-extract-plugin
export default {"-large":"color-picker-v2-module__-large--IuXG2","container":"color-picker-v2-module__container--OBXF6"};